import { Row } from "@amzn/stencil-react-components/layout";
import IconCheckCircleFill from "@amzn/stencil-react-icons/icons/icon-check-circle-fill";
import { IconSize } from "@amzn/stencil-react-icons/icons/interfaces";
import { ItemStatus } from "common/types/catalog-types";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FunctionComponent } from "react";

const EXTRA_DAYS = 1;

export interface EtaStatusIndicatorProps {
  etaDays: number;
  hasStock: boolean;
  size: IconSize;
  /** Optional item status — when "unsanctioned" renders a "Requires security review" label */
  status?: string;
}

export const EtaStatusIndicator: FunctionComponent<EtaStatusIndicatorProps> = ({ etaDays, hasStock, size, status }) => {
  if (status === ItemStatus.unsanctioned) {
    return (
      <Row gridGap="S300">
        <strong>{getString("eta.statusIndicator.securityReviewRequired")}</strong>
      </Row>
    );
  }

  if (hasStock === true || etaDays == 0) {
    return (
      <Row gridGap="S300" alignItems="center">
        <IconCheckCircleFill color="green70" size={size} />
        <strong>{getString("eta.statusIndicator.available")}</strong>
      </Row>
    );
  }
  const daysRange = `${etaDays}-${etaDays + EXTRA_DAYS}`;
  return (
    <Row gridGap="S300">
      <strong>{getString("eta.statusIndicator.wait", { daysRange })}</strong>
    </Row>
  );
};
